"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_INDUSTRIES_HASH = void 0;
exports.GET_INDUSTRIES_HASH = `
  {
    industries
  }
`;
//# sourceMappingURL=industries-queries.js.map